module.exports = __webpack_public_path__ + "assets/img/bcddbcba0d3788b4f437bffb73ee44f2.svg";